export default "__VITE_ASSET__DcxO0T2S__"